export default "__VITE_ASSET__d5cbc91c__"